<template>
  <div class="check-phone-wrapper">
    <PhoneVerifyDialog ref="phoneDialog" :phoneState="phoneApiState" @success="handlePhoneVerifySuccess" @error="handlePhoneVerifyError" @close="handlePhoneVerifyClose" />
  </div>
</template>

<script>
import PhoneVerifyDialog from './PhoneVerifyDialog.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'GlobalCheckPhone',
  components: {
    PhoneVerifyDialog
  },
  computed: {
    ...mapGetters('globalCheck', ['phoneApiState'])
  },
  methods: {
    handlePhoneVerifySuccess() {
      this.$store.dispatch('globalCheck/handleDialogShown', 'phone');
    },

    handlePhoneVerifyError(error) {
      console.error('手机号验证失败:', error);
    },

    handlePhoneVerifyClose() {
      this.$store.dispatch('globalCheck/handleDialogShown', 'phone');
    }
  }
}
</script>

<style scoped lang="scss">
.check-phone-wrapper {
  // 样式可以根据需要添加
}
</style> 